import { useState, useEffect, useContext } from "react";
import useWindowSize from "../../../hooks/useWindowSize.jsx";
import { MdMenuOpen, MdOutlineDashboard } from "react-icons/md";
import { BiLogOut, BiUser, BiWalletAlt } from "react-icons/bi";
import { TbBrandProducthunt } from "react-icons/tb";
import "./management.scss";
import { FiMessageSquare } from "react-icons/fi";
import { ImFileText } from "react-icons/im";
import { FiSettings } from "react-icons/fi";
import {
  RiOrderPlayLine,
  RiFolderUserLine,
  RiPlayListAddFill,
} from "react-icons/ri";

import styles from "./manage.module.css";
import { NavLink, Link } from "react-router-dom";
import { BsCardImage, BsWallet2 } from "react-icons/bs";
import AuthenticationContext from "../../../context/Authentication/AuthenticationContext.tsx";

export default function ManagementSidebar({ requestIdHandler, accessLevel }) {
  const { logout } = useContext(AuthenticationContext);

  const [isOpen, setIsOpen] = useState(false);
  const { width } = useWindowSize();

  useEffect(() => {
    if (width && width > 992 && isOpen === false) {
      setIsOpen(true);
    }
    if (width && width < 992 && isOpen === true) {
      setIsOpen(false);
    }
  }, [width]);
  // console.log("acces", accessLevel);
  return (
    <>
      {width && width < 992 && (
        <button
          style={{
            position: "fixed",
            zIndex: "10",
            top: "85px",
            right: "13px",
            backgroundColor: "#ccc",
          }}
          className="btn btn-mobile-menu mt-4 "
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        >
          <MdMenuOpen></MdMenuOpen>
        </button>
      )}

      {isOpen && (
        <div
          className={` manag d-block ${
            width && width < 992 && "mobile-sidebar"
          } ${styles.sidebarr}`}
          style={{
            width: "255px",
            position: "sticky",
            top: "-15",
            height: "100%",
            // height: "auto",
            // minHeight: "100vh",

            zIndex: "9",
            backgroundColor: "#ccc",
          }}
        >
          <ul
            className={`menu1 nav nav-pills mt-5 pb-5 flex-column mb-sm-auto 
             mb-0 align-items-center justify-content-around px-2 ${styles.ulProfile} `}
            id="menu"
          >
            {accessLevel.includes(108) && (
              <li
                className={`d-flex  text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
              >
                <button
                  className="nav-link d-flex align-items-center"
                  id="pills-dashboard-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-dashboard"
                  type="button"
                  role="tab"
                  aria-controls="pills-dashboard"
                  aria-selected="false"
                  onClick={() => {
                    requestIdHandler(1);
                    width < 992 && setIsOpen(false);
                  }}
                >
                  {/* <p className="icon-container"> */}{" "}
                  <MdOutlineDashboard className="mx-2 " /> {/* </p> */}
                  <bdi className="mt-2 txt-t1-m">داشبورد</bdi>
                </button>
                {/* <NavLink
                to="/super-admin-panel/dashboard"
                style={{ textDecoration: "none" }}
                className={(navData) =>
                  navData.isActive ? "activeLink" : "nav-link "
                }
              >
                
              </NavLink> */}
              </li>
            )}
            {(accessLevel.includes(104) || accessLevel.includes(105)) && (
              <li
                className={`d-flex mt-3 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
              >
                <button
                  className="nav-link  d-flex align-items-center"
                  id="pills-business-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-business"
                  type="button"
                  role="tab"
                  aria-controls="pills-business"
                  aria-selected="false"
                  onClick={() => {
                    requestIdHandler(2);
                    width < 992 && setIsOpen(false);
                  }}
                >
                  {/* <p className="icon-container"> */}{" "}
                  <BiUser className="mx-2" />
                  {/* </p> */}
                  <bdi className="mt-2 txt-t1-m">کسب و کار</bdi>
                </button>
                {/* <NavLink
                to="/super-admin-panel/bussiness"
                style={{ textDecoration: "none" }}
                className={(navData) =>
                  navData.isActive ? "activeLink" : "nav-link "
                }
              >
              </NavLink> */}
              </li>
            )}
            {(accessLevel.includes(100) || accessLevel.includes(102)) && (
              <li
                className={`d-flex mt-3 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
              >
                <button
                  className="nav-link  d-flex align-items-center"
                  id="pills-product-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-product"
                  type="button"
                  role="tab"
                  aria-controls="pills-product"
                  aria-selected="false"
                  onClick={() => {
                    requestIdHandler(3);
                    width < 992 && setIsOpen(false);
                  }}
                >
                  {/* <p className="icon-container"> */}{" "}
                  <ImFileText className="mx-2" />
                  {/* </p> */}
                  <bdi className="mt-2 txt-t1-m">محصولات</bdi>
                </button>
                {/* <NavLink
                to="/super-admin-panel/kala"
                className={(navData) =>
                  navData.isActive ? "activeLink" : "nav-link "
                }
                style={{ textDecoration: "none" }}
              >
              </NavLink> */}
              </li>
            )}
            {/* <div
              className={`d-flex mt-2 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
            >
              <NavLink
                to="/super-admin-panel/marketer"
                style={{ textDecoration: "none" }}
                className={(navData) =>
                  navData.isActive ? "activeLink" : "nav-link "
                }
              >
                <FiSettings className="mx-2" />
                <bdi className="mt-2">بازاریاب</bdi>
              </NavLink>
            </div> */}
            {/* <div
              className={`d-flex mt-4 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
            >
              <NavLink
                to="/super-admin-panel/cart-list "
                style={{ textDecoration: "none" }}
                className={(navData) =>
                  navData.isActive ? "activeLink" : "nav-link "
                }
              >
                <FiMessageSquare className="mx-2" />
                <bdi className="mt-2"> لیست سبد </bdi>
              </NavLink>
            </div> */}
            {accessLevel.includes(106) && (
              <li
                className={`d-flex mt-3 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
              >
                <button
                  className="nav-link  d-flex align-items-center"
                  id="pills-customerClub-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-customerClub"
                  type="button"
                  role="tab"
                  aria-controls="pills-customerClub"
                  aria-selected="false"
                  onClick={() => {
                    requestIdHandler(4);
                    width < 992 && setIsOpen(false);
                  }}
                >
                  {/* <p className="icon-container"> */}{" "}
                  <FiMessageSquare className="mx-2" />
                  {/* </p> */}
                  <bdi className="mt-2 txt-t1-m"> باشگاه مشتریان </bdi>
                </button>
                {/* <NavLink
                to="/super-admin-panel/customer-club"
                style={{ textDecoration: "none" }}
                className={(navData) =>
                  navData.isActive ? "activeLink" : "nav-link "
                }
              >
              </NavLink> */}
              </li>
            )}

            {accessLevel.includes(107) && (
              <li
                className={`d-flex mt-3 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
              >
                <button
                  className="nav-link  d-flex align-items-center"
                  id="pills-finance-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-finance"
                  type="button"
                  role="tab"
                  aria-controls="pills-finance"
                  aria-selected="false"
                  onClick={() => {
                    requestIdHandler(5);
                    width < 992 && setIsOpen(false);
                  }}
                >
                  {/* <p className="icon-container"> */}{" "}
                  <BsWallet2 className="mx-2" /> {/* </p> */}
                  <bdi className="mt-2 txt-t1-m">امور مالی </bdi>
                </button>
                {/* <NavLink
                to="/super-admin-panel/financial-management"
                style={{ textDecoration: "none" }}
                className={(navData) =>
                  navData.isActive ? "activeLink" : "nav-link "
                }
              >
                
              </NavLink> */}
              </li>
            )}

            {/* <div
              className={`d-flex mt-2 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
            >
              <NavLink
                to="/super-admin-panel/transactions"
                style={{ textDecoration: "none" }}
                className={(navData) =>
                  navData.isActive ? "activeLink" : "nav-link "
                }
              >
                <BsWallet2 className="mx-2" />
                <bdi className="mt-2">لیست تراکنشها</bdi>
              </NavLink>
            </div> */}
            {accessLevel.includes(107) && (
              <li
                className={`d-flex mt-3 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
              >
                <button
                  className="nav-link  d-flex align-items-center"
                  id="pills-wallet-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-wallet"
                  type="button"
                  role="tab"
                  aria-controls="pills-wallet"
                  aria-selected="false"
                  onClick={() => {
                    // console.log("HERE");
                    requestIdHandler(6);
                    width < 992 && setIsOpen(false);
                    // setIsOpen(false);
                  }}
                >
                  {/* <p className="icon-container"> */}{" "}
                  <BiWalletAlt className="mx-2" />
                  {/* </p> */}
                  <bdi className="mt-2 txt-t1-m"> لیست ولت </bdi>
                </button>
                {/* <NavLink
                to="/super-admin-panel/wallets"
                style={{ textDecoration: "none" }}
                className={(navData) =>
                  navData.isActive ? "activeLink" : "nav-link "
                }
              >
                
              </NavLink> */}
              </li>
            )}
            {accessLevel.includes(103) && (
              <li
                className={`d-flex mt-3 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
              >
                <button
                  className="nav-link  d-flex align-items-center"
                  id="pills-order-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-order"
                  type="button"
                  role="tab"
                  aria-controls="pills-order"
                  aria-selected="false"
                  onClick={() => {
                    requestIdHandler(7);
                    width < 992 && setIsOpen(false);
                  }}
                >
                  {/* <p className="icon-container"> */}{" "}
                  <RiOrderPlayLine className="mx-2" />
                  {/* </p> */}
                  <bdi className="mt-2 txt-t1-m">سفارشات</bdi>
                </button>
                {/* <NavLink
                to="/super-admin-panel/orders"
                style={{ textDecoration: "none" }}
                className={(navData) =>
                  navData.isActive ? "activeLink" : "nav-link "
                }
              >
                
              </NavLink> */}
              </li>
            )}
            {accessLevel.includes(101) && (
              <li
                className={`d-flex mt-3 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
              >
                <button
                  className="nav-link  d-flex align-items-center"
                  id="pills-user-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-user"
                  type="button"
                  role="tab"
                  aria-controls="pills-user"
                  aria-selected="false"
                  onClick={() => {
                    requestIdHandler(8);
                    width < 992 && setIsOpen(false);
                  }}
                >
                  {/* <p className="icon-container"> */}{" "}
                  <RiFolderUserLine className="mx-2" />
                  {/* </p> */}
                  <bdi className="mt-2 txt-t1-m">مدیریت کاربران</bdi>
                </button>
                {/* <NavLink
                to="/super-admin-panel/customer-management"
                style={{ textDecoration: "none" }}
                className={(navData) =>
                  navData.isActive ? "activeLink" : "nav-link "
                }
              >
                
              </NavLink> */}
              </li>
            )}
            {(accessLevel.includes(100) || accessLevel.includes(102)) && (
              <li
                className={`d-flex mt-3 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
              >
                <button
                  className="nav-link  d-flex align-items-center"
                  id="pills-supplier-product-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-supplier-product"
                  type="button"
                  role="tab"
                  aria-controls="pills-supplier-product"
                  aria-selected="false"
                  onClick={() => {
                    requestIdHandler(9);
                    width < 992 && setIsOpen(false);
                  }}
                >
                  <RiPlayListAddFill className="mx-2" />

                  <bdi className="mt-2 txt-t1-m"> محصولات‌فروشگاه</bdi>
                </button>
              </li>
            )}
            <li
              className={`d-flex mt-3 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
            >
              <button
                className="nav-link  d-flex align-items-center"
                id="pills-banner-management-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-banner-management"
                type="button"
                role="tab"
                aria-controls="pills-banner-management"
                aria-selected="false"
                onClick={() => {
                  requestIdHandler(10);
                  width < 992 && setIsOpen(false);
                }}
              >
                <BsCardImage className="mx-2" />

                <bdi className="mt-2 txt-t1-m"> مدیریت بنرها</bdi>
              </button>
            </li>
            <li
              className={`d-flex mt-3 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
            >
              <button
                className="nav-link  d-flex align-items-center"
                id="pills-requested-products-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-requested-products"
                type="button"
                role="tab"
                aria-controls="pills-requested-products"
                aria-selected="false"
                onClick={() => {
                  requestIdHandler(11);
                  width < 992 && setIsOpen(false);
                }}
              >
                <TbBrandProducthunt className="mx-2" />

                <bdi className="mt-2 txt-t1-m"> محصول درخواستی </bdi>
              </button>
            </li>
            <li
              className={`d-flex mt-3 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
            >
              <button
                className="nav-link  d-flex align-items-center"
                id="pills-exit-tab"
                onClick={() => {
                  logout();
                  width < 992 && setIsOpen(false);
                }}
              >
                {/* <p className="icon-container"> */}{" "}
                <BiLogOut className="mx-2" />
                {/* </p> */}
                <bdi className="mt-2 txt-t1-m">خروج</bdi>
              </button>
              {/* <NavLink
            to="/super-admin-panel/customer-management"
            style={{ textDecoration: "none" }}
            className={(navData) =>
              navData.isActive ? "activeLink" : "nav-link "
            }
          >
            
          </NavLink> */}
            </li>
          </ul>
        </div>
      )}
    </>
  );
}
// {isOpen && (
//   <div
//     className={`manag d-block ${
//       width && width < 992 && "mobile-sidebar"
//     } ${styles.sidebarr}`}
//     style={{
//       width: "255px",
//       position: "sticky",
//       top: "-15",
//       height: "auto",
//       // minHeight: "100vh",

//       zIndex: "9",
//       backgroundColor: "#ccc",
//     }}
//   >
//     <ul
//       className={`menu1 nav nav-pills mt-2 pb-5 flex-column mb-sm-auto
//        mb-0 align-items-center justify-content-around px-2 ${styles.ulProfile} `}
//       id="menu"
//     >
//       <div
//         className={`d-flex mt-5 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
//       >
//         <NavLink
//           to="/super-admin-panel/dashboard"
//           style={{ textDecoration: "none" }}
//           className={(navData) =>
//             navData.isActive ? "activeLink" : "nav-link "
//           }
//         >
//           <MdOutlineDashboard className="mx-2 " />
//           <bdi className="mt-2">داشبورد</bdi>
//         </NavLink>
//       </div>
//       <div
//         className={`d-flex mt-3 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
//       >
//         <NavLink
//           to="/super-admin-panel/bussiness"
//           style={{ textDecoration: "none" }}
//           className={(navData) =>
//             navData.isActive ? "activeLink" : "nav-link "
//           }
//         >
//           <BiUser className="mx-2" />
//           <bdi className="mt-2">کسب و کار</bdi>
//         </NavLink>
//       </div>
//       <div
//         className={`d-flex mt-3 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
//       >
//         <NavLink
//           to="/super-admin-panel/kala"
//           className={(navData) =>
//             navData.isActive ? "activeLink" : "nav-link "
//           }
//           style={{ textDecoration: "none" }}
//         >
//           <ImFileText className="mx-2" />
//           <bdi className="mt-2">محصولات</bdi>
//         </NavLink>
//       </div>
//       {/* <div
//         className={`d-flex mt-2 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
//       >
//         <NavLink
//           to="/super-admin-panel/marketer"
//           style={{ textDecoration: "none" }}
//           className={(navData) =>
//             navData.isActive ? "activeLink" : "nav-link "
//           }
//         >
//           <FiSettings className="mx-2" />
//           <bdi className="mt-2">بازاریاب</bdi>
//         </NavLink>
//       </div> */}
//       {/* <div
//         className={`d-flex mt-4 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
//       >
//         <NavLink
//           to="/super-admin-panel/cart-list "
//           style={{ textDecoration: "none" }}
//           className={(navData) =>
//             navData.isActive ? "activeLink" : "nav-link "
//           }
//         >
//           <FiMessageSquare className="mx-2" />
//           <bdi className="mt-2"> لیست سبد </bdi>
//         </NavLink>
//       </div> */}
//       <div
//         className={`d-flex mt-3 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
//       >
//         <NavLink
//           to="/super-admin-panel/customer-club"
//           style={{ textDecoration: "none" }}
//           className={(navData) =>
//             navData.isActive ? "activeLink" : "nav-link "
//           }
//         >
//           <FiMessageSquare className="mx-2" />
//           <bdi className="mt-2"> باشگاه مشتریان </bdi>
//         </NavLink>
//       </div>

//       <div
//         className={`d-flex mt-3 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
//       >
//         <NavLink
//           to="/super-admin-panel/financial-management"
//           style={{ textDecoration: "none" }}
//           className={(navData) =>
//             navData.isActive ? "activeLink" : "nav-link "
//           }
//         >
//           <BsWallet2 className="mx-2" />
//           <bdi className="mt-2">امور مالی </bdi>
//         </NavLink>
//       </div>

//       {/* <div
//         className={`d-flex mt-2 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
//       >
//         <NavLink
//           to="/super-admin-panel/transactions"
//           style={{ textDecoration: "none" }}
//           className={(navData) =>
//             navData.isActive ? "activeLink" : "nav-link "
//           }
//         >
//           <BsWallet2 className="mx-2" />
//           <bdi className="mt-2">لیست تراکنشها</bdi>
//         </NavLink>
//       </div> */}
//       <div
//         className={`d-flex mt-3 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
//       >
//         <NavLink
//           to="/super-admin-panel/wallets"
//           style={{ textDecoration: "none" }}
//           className={(navData) =>
//             navData.isActive ? "activeLink" : "nav-link "
//           }
//         >
//           <BiWalletAlt className="mx-2" />
//           <bdi className="mt-2"> لیست ولت </bdi>
//         </NavLink>
//       </div>
//       <div
//         className={`d-flex mt-3 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
//       >
//         <NavLink
//           to="/super-admin-panel/orders"
//           style={{ textDecoration: "none" }}
//           className={(navData) =>
//             navData.isActive ? "activeLink" : "nav-link "
//           }
//         >
//           <RiOrderPlayLine className="mx-2" />
//           <bdi className="mt-2">سفارشات</bdi>
//         </NavLink>
//       </div>
//       <div
//         className={`d-flex mt-3 text-dark d-flex justify-content-start align-items-center ${styles.sidebarLink}`}
//       >
//         <NavLink
//           to="/super-admin-panel/customer-management"
//           style={{ textDecoration: "none" }}
//           className={(navData) =>
//             navData.isActive ? "activeLink" : "nav-link "
//           }
//         >
//           <RiFolderUserLine className="mx-2" />
//           <bdi className="mt-2">مدیریت کاربران</bdi>
//         </NavLink>
//       </div>
//     </ul>
//   </div>
// )}
